import type { SchedulerLike } from "rxjs";

import { DIID } from "@archipad-js/dependency-injection";

import { CoreError } from "@archipad-js/core/error";

import { ConfigBundle } from "./config-bundle";
import { ConfigService } from "./config.service";
import { ConfigOperator } from "./config-operator";
import { ConfigConstant } from "./config-contant";

export const Config_Bundle_DIID = DIID<ConfigBundle>("Config.Bundle");
export const Config_Constant_DIID = DIID<ConfigConstant>("Config.Constant");
export const Config_Operator_DIID = DIID<ConfigOperator>("Config.Operator");
export const Config_Service_DIID = DIID<ConfigService>("Config.Service");
export const Config_Service_Scheduler_DIID = DIID<SchedulerLike>("Config.Service.Scheduler");

export interface BuiltInOperator {
    str: string;
}

export interface CustomOperator extends Record<string, unknown> {
    "func:": string;
}

export interface ExpressionAspectPath {
    type: "expr";
    value: string;
}

export interface IdentifierAspectPath {
    type: "ident";
    value: string;
}

export interface IndexAspectPath {
    type: "index";
    value: number;
}

export interface StarAspectPath {
    type: "star";
}

export type AspectPath = ExpressionAspectPath | IdentifierAspectPath | IndexAspectPath | StarAspectPath;

export class ConfigError extends CoreError {}

/**
 * A configuration update (from a bundle aspect) that could not be applied
 */
export interface FailedConfigUpdate {
    bundle: string;
    aspect: string;
    /** path the aspect is applied on */
    path: string;
    /** key of the update operation, undefined when the whole aspect failed */
    key?: string;
    error: Error;
}

/**
 * Some configuration updates could not be applied and have been skipped
 * (ex: a configuration made for another version of the application)
 */
export class ConfigUpdateError extends ConfigError {
    constructor(public readonly failedUpdates: readonly FailedConfigUpdate[]) {
        super(`Configuration updates could not be applied: ${failedUpdates.map(formatFailedConfigUpdate).join(", ")}`);
    }
}

export function formatFailedConfigUpdate(failedUpdate: FailedConfigUpdate): string {
    return `${failedUpdate.key ?? failedUpdate.path} (${failedUpdate.aspect})`;
}
